import { render, staticRenderFns } from "./income-statement-detail.vue?vue&type=template&id=0b8d4f09&"
import script from "./income-statement-detail.vue?vue&type=script&lang=js&"
export * from "./income-statement-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports